import { Box, Container, SvgIcon } from "@mui/material";
import axiosInstance from "app/axios";
import { useAppDispatch, useAppSelector } from "app/hooks";
import Header from "components/header/Header";
import SearchBar from "components/inputs/HolzfinderSearchBar";
import HolzfinderList from "components/list/HolzfinderList";
import { selectSorting } from "features/lotlist/filterAndSortSlice";
import {
  getLotList,
  selectLotList,
  selectLotListTotal,
  setLosItemStatus,
} from "features/lotlist/lotListSlice";
import { selectLotListTab, selectPageLotList, selectRowsPerPageLotList, setLotListTab, setPageLotList, setRowsPerPageLotList } from "features/table/tableSlice";
import { selectUserRole } from "features/user/userSlice";
import formatDate from "hooks/useDate";
import { getFirstImageThumbnail } from "hooks/useFirstImage";
import { Delete, Standby, Euro } from "icons";
import * as React from "react";
import { createContext, useEffect, useState, useCallback, useMemo } from "react";
import BulkEditModal from "./BulkEditModal";
import LotListTabs from "./LotListTabs";
import BulkDelete from "./modals/BulkDelete";
import BulkPriceEdit from "./modals/BulkPriceEdit";
import BulkStatusEdit from "./modals/BulkStatusEdit";
import PleaseSelect from "./modals/PleaseSelect";

interface rowInterface {
  id: string;
  checked: boolean;
  lot_number: string;
  date: string;
  kind: string;
  wood_type: string;
  volume: string;
  length: string;
  diameter: string;
  price: string;
  // gross_price: string;
  net_price: string;
  status: string;
  eligible_for_status_change: boolean;
  src: string;
}

enum LOT_LIST_TABS {
  ALL,
  ACTIVE,
  INACTIVE,
  SOLD,
  PLANNED
}


export const lotListTabNames = ['', 'active', 'inactive', 'sold', 'planned']

const tableHeaderListAdmin = ['Bild', 'Kreisnr.', 'Los-Nr.', 'Eingestellt seit', 'Sorte', 'Holzart', 'Volumen [FmoR]', 'Ø-Länge', 'Ø-Durchm.', '€ / fm (netto)', 'Preis netto', 'Aktiv', 'Bearbeiten']
const sortableHeaders = ['Kreisnr.', 'Los-Nr.', 'Eingestellt Seit', 'Holzart', 'Volumen [FmoR]', 'Ø-Länge', 'Ø-Durchm.', '€ / fm (netto)', 'Preis netto']
const headersBackEndName = ["district_number", "lot_number", "published_at", "wood_type", "solid_cubic_meters_without_bark", "average_length_value", "diameter", "price_per_solid_cubic_meter", "price_total"]

const tableHeaderListAgent = ['Bild', 'Los-Nr.', 'Eingestellt seit', 'Sorte', 'Holzart', 'Volumen [FmoR]', 'Ø-Länge', 'Ø-Durchm.', '€ / fm (netto)', 'Preis netto', 'Aktiv', 'Bearbeiten']


export const ModalContext = createContext<{ modalOpened: boolean, handleOpen: any, handleClose: (clearCheckboxes?: boolean) => void, errorMessage?: string, errorOpened: boolean, handleErrorMessage: (value: string) => void }>({ modalOpened: false, handleOpen: () => console.error('handleOpen not implemented'), handleClose: (clearCheckboxes = false) => console.error('handleClose not implemented'), errorOpened: false, handleErrorMessage: () => console.error('setErrorMessage not implemented') });
export default function LosListe() {
  const numberFormatter = useMemo(() => new Intl.NumberFormat("de-De", { maximumSignificantDigits: 2 }), []);
  const [searchQuery, setSearchQuery] = useState();
  const [rowData, setRowData] = useState<rowInterface[]>([]);
  const lotList = useAppSelector(selectLotList);
  const lotListTotal = useAppSelector(selectLotListTotal);
  const dispatch = useAppDispatch();
  const userRole = useAppSelector(selectUserRole);
  const page = useAppSelector(selectPageLotList)
  const rowsPerPage = useAppSelector(selectRowsPerPageLotList)
  const tab = useAppSelector(selectLotListTab)
  const priceFormatter = useMemo(() => new Intl.NumberFormat("de-De", { style: "currency", currency: "EUR" }), []);
  const sort = useAppSelector(selectSorting)
  const [checkedBoxes, setCheckedBoxes] = useState<string[]>([])

  const receiveLotList = useCallback(() => {
    dispatch(
      getLotList({
        items_per_page: rowsPerPage,
        page: page + 1,
        search: searchQuery,
        status: lotListTabNames[tab],
        sort: sort,
      })
    ).catch((e) => {
      console.error(e)
    });
  }, [dispatch, rowsPerPage, page, searchQuery, tab, sort])

  useEffect(() => {
    setCheckedBoxes([]);
  }, [tab]);

  useEffect(() => {
    if (userRole === "admin") {
      const filteredAndMappedData = lotList
        .map((row) => ({
          id: row.id,
          //@ts-ignore
          src: getFirstImageThumbnail(row.images),
          district: userRole === "admin" && row.agent ? row.agent.county_eldat_reference_id : null,
          lot_number: row.lot_number,
          date: row.published_at && row.status === "planned" ? "geplant für " + formatDate(row.published_at) : row.published_at ? formatDate(row.published_at) : "----",
          kind: row.wood_category.name,
          wood_type: row.lot_offers_wood_types.map((woodType) => woodType.wood_type.name).join(", "),
          volume: parseFloat(row.solid_cubic_meters_without_bark).toFixed(2).replace('.', ',') + " Fm",
          length: parseFloat(row.average_length_value).toFixed(2).replace('.', ',') + " m",
          diameter: parseInt(numberFormatter.format(Number.parseFloat(row.diameter))).toFixed(0) + " cm",
          price: priceFormatter.format(Number.parseFloat(row.price_per_solid_cubic_meter)),
          // gross_price: Number.parseFloat(row.price_total)
          //   .toFixed(2)
          //   .replace(/(\d)(?=(\d{3})+(?!\d))/g, "1") + "€",
          net_price: priceFormatter.format(Number.parseFloat(row.price_total)),
          status: row.status,
          checked: row.status === "active" ? true : false,
          eligible_for_status_change: parseFloat(row.price_per_solid_cubic_meter) > 0,
        }));
      setRowData(filteredAndMappedData);
    } else {
      const filteredAndMappedData = lotList
        .map((row) => ({
          id: row.id,
          //@ts-ignore
          src: getFirstImageThumbnail(row.images),
          lot_number: row.lot_number,
          date: row.published_at && row.status === "planned" ? "geplant für " + formatDate(row.published_at) : row.published_at ? formatDate(row.published_at) : "----",
          kind: row.wood_category.name,
          wood_type: row.lot_offers_wood_types.map((woodType) => woodType.wood_type.name).join(","),
          volume: parseFloat(row.solid_cubic_meters_without_bark).toFixed(2).replace('.', ',') + " Fm",
          length: parseFloat(row.average_length_value).toFixed(2).replace('.', ',') + " m",
          diameter: parseInt(numberFormatter.format(Number.parseFloat(row.diameter))).toFixed(0) + " cm",
          price: priceFormatter.format(Number.parseFloat(row.price_per_solid_cubic_meter)),
          // gross_price: Number.parseFloat(row.price_total)
          //   .toFixed(2)
          //   .replace(/(\d)(?=(\d{3})+(?!\d))/g, "1") + "€",
          net_price: priceFormatter.format(Number.parseFloat(row.price_total)),
          status: row.status,
          checked: row.status === "active" ? true : false,
          eligible_for_status_change: parseFloat(row.price_per_solid_cubic_meter) > 0,
        }));
      setRowData(filteredAndMappedData);
    }
  }, [lotList, userRole, numberFormatter, priceFormatter]);

  useEffect(() => {
    receiveLotList()
  }, [tab, page, rowsPerPage, sort, searchQuery, receiveLotList])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(setPageLotList(0))
    dispatch(setLotListTab(newValue));
  };

  const switchStatus = (id: string, _: boolean) => {   
    for (const row of rowData) {
      if (row.id === id) {
        const payload: any = {};
        payload["status"] = row.status === "active" ? "inactive" : "active";
        axiosInstance.patch(`${userRole}/lot_offers/${row.id}`, payload).then((result) => {
          if (result.status === 200) {
            dispatch(setLosItemStatus({ id: row.id, status: payload["status"] }))
          } else {
            console.error("Error in Axios:", result);
          }
        }).catch((e) => {
          console.error(e)
        });
        break;
      }
    }
  };

  useEffect(() => {
    dispatch(setPageLotList(0));
  }, [dispatch, searchQuery]);


  return (
    <Container sx={{ pl: { lg: 12, md: 12, xs: 12 }, pt: 5 }} maxWidth="xl">
      <Header header="Losliste" />
      <SearchBar page={page} rowsPerPage={rowsPerPage} getListType={receiveLotList} status={lotListTabNames[tab]} tab={tab} setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", flexWrap: "wrap-reverse", alignItems: "center", rowGap: 2}}>
        <LotListTabs
          activeTab={tab}
          handleTabChange={handleTabChange}
          tabInfo={[
            { name: "Alle", color: tab === LOT_LIST_TABS.ALL ? "#ffffff" : "" },
            { name: "Aktiv", color: tab === LOT_LIST_TABS.ACTIVE ? "#D9E868" : "" },
            { name: "Inaktiv", color: tab === LOT_LIST_TABS.INACTIVE ? "#FF6A7D" : "" },
            { name: "Verkauft", color: tab === LOT_LIST_TABS.SOLD ? "#CBCFD3" : "" },
            { name: "Geplant", color: tab === LOT_LIST_TABS.PLANNED ? "#83C0F8" : "" },
            // TODO: As long as we don't handle invoices, we don't need those
            // "Offene Rechnungen",
            // "Bezahlte Rechnungen",
          ]}
        />

        <Box display={"flex"} flexDirection="row" gap={2} alignItems="center" flexGrow={1} justifyContent={"flex-end"}>
          <BulkEditModal icon={<SvgIcon><Delete /></SvgIcon>} title="Alle markierten Lose löschen" setCheckedBoxes={setCheckedBoxes}>
            {checkedBoxes.length > 0 ?
              <BulkDelete checkedBoxes={checkedBoxes} searchQuery={searchQuery} />
              :
              <PleaseSelect />
            }
          </BulkEditModal>
          <BulkEditModal icon={<SvgIcon><Standby /></SvgIcon>} title="Status aller markierten Lose ändern" disabled={tab === LOT_LIST_TABS.SOLD} setCheckedBoxes={setCheckedBoxes}>
            {checkedBoxes.length > 0 ?
              <BulkStatusEdit checkedBoxes={checkedBoxes} searchQuery={searchQuery} />
              :
              <PleaseSelect />
            }
          </BulkEditModal>
          <BulkEditModal icon={<SvgIcon><Euro /></SvgIcon>} title="Preis aller markierten Lose bearbeiten" disabled={tab === LOT_LIST_TABS.SOLD} setCheckedBoxes={setCheckedBoxes}>
            {checkedBoxes.length > 0 ?
              <BulkPriceEdit checkedBoxes={checkedBoxes} searchQuery={searchQuery} />
              :
              <PleaseSelect />
            }
          </BulkEditModal>
        </Box>
      </Box>
      <HolzfinderList
        listLengthTotal={lotListTotal}
        rowData={rowData}
        switchActive={true}
        link={`/${userRole}/losliste/`}
        tab={tab}
        switchStatus={switchStatus}
        tableHeaderList={userRole === "admin" ? tableHeaderListAdmin : tableHeaderListAgent}
        sortableHeaders={sortableHeaders}
        headersBackEndName={headersBackEndName}
        setPage={setPageLotList}
        setRowsPerPage={setRowsPerPageLotList}
        page={page}
        rowsPerPage={rowsPerPage === undefined ? 10 : rowsPerPage}
        isLotList={true}
        checkedBoxes={checkedBoxes}
        setCheckedBoxes={setCheckedBoxes}
      // handleSortChange={handleSortChange}
      />
    </Container>
  );
}

